import { TlfUpdateActionSignal } from "contexts/signalr/interface";
import { FROM_SIGNALR, ITlfActionFromSignalR } from "./tocContextReducer";

/**
 * Process a TLF update action received from SignalR and convert it into
 * the internal `ITlfActionFromSignalR` shape used by the ToC reducer.
 *
 * @param messageId - The SignalR message identifier for this event.
 * @param actionSignal - The TLF update action payload received from SignalR.
 * @returns The transformed `ITlfActionFromSignalR` object ready for reducer dispatch.
 */
export const processTlfActionFromSignal = (
  messageId: string,
  actionSignal: TlfUpdateActionSignal,
): ITlfActionFromSignalR => {
  const updatedId: string = actionSignal.updatedItemId;
  return {
    operation: FROM_SIGNALR,
    item: JSON.stringify(actionSignal.patch),
    receivedMessage: { messageId, updateTS: new Date(), updatedId },
  };
};
